package entities

import kotlinx.serialization.Serializable

@Serializable
data class OrgProduct(
    val id: Int,
    val org_id: Int,
    val prod_id: Int,
    val fo: String,
    val note: String
)